export enum PlanStatus {
  UNSET_STATE = 'UNSET_STATE', // Do not use, needed because of proto3 limitations
  ACTIVATED = 'ACTIVATED',
  PENDING = 'PENDING',
  TERMINATED = 'TERMINATED',
}
